import { render, staticRenderFns } from "./MyCarousel.vue?vue&type=template&id=9bb9199a&scoped=true"
import script from "./MyCarousel.vue?vue&type=script&lang=js"
export * from "./MyCarousel.vue?vue&type=script&lang=js"
import style0 from "./MyCarousel.vue?vue&type=style&index=0&id=9bb9199a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb9199a",
  null
  
)

export default component.exports